<template>
  <content-layout :title="title" :headImage="headImage" :isChildren="isChildren" :tabs="tabs" v-model="activeTab">
    <!-- <div class="icons" slot="icons">
      <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button>
    </div> -->
    <div slot="slogan">
    </div>
    <div class="activity-item mgui-container" slot="/analysis">
      <template v-if="$menu.isPower('analysis', 'view')">
        <div class="filter-row" style="text-align:center">
          <Button type="primary" style="float:right;margin-left:5px" icon="md-cloud-upload" v-if="$menu.isPower('analysis', 'import')" @click="exportAnalysis">导出数据</Button>
          <Divider type="vertical" style="float:right;margin-top:10px"></Divider>
          <Button type="success" style="float:right;margin-left:5px" icon="md-cloud-upload" v-if="$menu.isPower('analysis', 'import')" @click="uploadAnalysisModal=true">导入数据</Button>
          <Button type="default" icon="md-add" @click="create" style="float:right">增加数据</Button>
          <Button @click="lastYear"><Icon type="md-arrow-back"></Icon></Button>
          <DatePicker type="year" confirm :open="open" placeholder="Select year" style="width: 200px" @on-change="handleChange" @on-ok="handleOk">
            <a href="javascript:void(0)" @click="handleClick" style="font-size:16px">
                <Icon type="md-calendar-circle"></Icon>
                <template v-if="params.year === ''">选择时间</template>
                <template v-else>{{ params.year }} 年</template>
            </a>
          </DatePicker>
          <Button @click="nextYear"><Icon type="md-arrow-forward"></Icon></Button>
        <!-- 时间： -->
        <!-- <DatePicker type="year" :value="' '+params.year" placeholder="选择时间" @on-change="yearChange" style="width: 100px"></DatePicker>&nbsp;&nbsp; -->
        <!-- <Cascader v-model="params.department_id" placeholder="选择项目组" :data="" style="width:200px;text-align:left;display:inline-block" change-on-select></Cascader> -->
        <!-- :disabled="!$menu.isPower('analysis', 'all')" -->
        <div style="float:left">
          <Select clearable @on-change="departmentChange" placeholder="部门" style="width:100px;text-align:left">
              <Option v-for="item in $store.state.department" :key="item.value" :value="JSON.stringify(item)">{{item.label}}</Option>
          </Select>&nbsp;
          <Select v-model="params.project_id" clearable @on-change="projectChange" placeholder="项目" style="width:200px;text-align:left">
            <Option v-for="child in projects" :key="child.value" :value="child.value">{{child.label}}</Option>
          </Select>&nbsp;
          <Poptip placement="bottom" trigger="hover" width="280" title="选择月份" v-model="monthVisible">
              <Button @click="monthVisible=true">
                {{params.month==''?'月份':params.month+'月'}} <Icon type="ios-arrow-down"></Icon>
              </Button>
              <div class="api" slot="content" style="white-space:normal;padding-bottom:10px;">
                  <span v-for="item in 12" :key="item" style="display:inline-block;width:60px">
                    <Button type="text" style="font-size:16px;" :style="{'color':item==params.month?'green':''}" @click="params.month=item;monthVisible=false;fetchData()">{{item}}<span style="font-size:12px;">月</span></Button>
                  </span>
                  <Button type="text" @click="params.month='';monthVisible=false;fetchData()" style="border-top:1px solid #eee;margin-top:10px" long>清除</Button>
              </div>
          </Poptip>
        </div>
      </div>
      <Modal v-model="analysisModal"  width="90" :footer-hide="true">
        <analysis-form :visible="analysisModal" :refresh="fetchData"></analysis-form>
      </Modal>
      <Modal v-model="analysisEditModal" title="编辑" :footer-hide="true">
        <analysis-edit-form :data="rowData" v-if="analysisEditModal" :refresh="refresh"></analysis-edit-form>
      </Modal>
      <div class="ivu-table-wrapper analysis-table"  v-if="results && results.data.length>0">
        <div class="ivu-table ivu-table-border ivu-table-stripe" style="overflow-x:scroll">
          <div class="ivu-table-body ivu-table-overflowX">
            <table cellspacing="0" cellpadding="0" border="0" style="width: 1651px;">
              <colgroup>
                <col width="260">
                <col width="120"><col width="100"><col width="110"><col width="110"><col width="110">
                <col width="100"><col width="100"><col width="120"><col width="100"><col width="150">
                <col width="110"><col width="100"><col width="120"><col width="100">
              </colgroup>
              <thead>
                <tr>
                  <!-- <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">负责人</span></div></th> -->
                  <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">项目名称</span></div></th>
                  <!-- <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">项目地</span></div></th> -->
                  <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">时间</span></div></th>
                  <th colspan="2" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">收入</span></div></th>
                  <th colspan="5" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">项目执行费用</span></div></th>
                  <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">项目借款</span></div></th>
                  <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">累计垫资</span></div></th>
                  <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">回款</span></div></th>
                  <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><a href="javascript:void(0);" title="(人工成本+负责人差旅+人员租赁费用+项目借款+前几月总成本-本月回款)*0.008">垫资成本</a></div></th>
                  <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><a href="javascript:void(0);" title="小计 + 垫资">项目总成本</a></div></th>
                  <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">操作</span></div></th>
                </tr>
                <tr>
                  <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">产值预估</span></div></th>
                  <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">调整产值</span></div></th>
                  <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">项目报销</span></div></th>
                   <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">人工成本</span></div></th>
                   <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">负责人差旅</span></div></th>
                   <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">人员租赁费</span></div></th>
                   <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">小计</span></div></th>
                 </tr>
               </thead>
               <tbody class="ivu-table-tbody">
                   <!-- <tr class="ivu-table-row">
                      <td class="ivu-table-column-center" :rowspan="item.project.length==0?1:item.project.length"><div class="ivu-table-cell"><span>{{item.name}}</span></div></td>
                      <td class="ivu-table-column-center" :rowspan="item.project.length==0?1:item.project.length"><div class="ivu-table-cell"><span>{{item.director.username||'--'}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.project[0].project}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.project[0].address}}</span></div></td>
                      <td class="ivu-table-column-center" :rowspan="item.project.length==0?1:item.project.length"><div class="ivu-table-cell"><span>{{item.time}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.project[0].expected|toFixed}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.project[0].expense_count|toFixed}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.project[0].salary_count|toFixed}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{(item.project[0].expense_count + item.project[0].salary_count)|toFixed}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                    </tr> -->
                    <tr v-for="(item, index) in results.data" class="ivu-table-row" :key="index">
                      <td class="ivu-table-column-left"><div class="ivu-table-cell"><span>{{item.project.name}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.year}}年{{item.month}}月</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.value}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.new_value}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.expense}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.labor_cost}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.travel_expenses}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.rental_cost}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{(item.expense + item.labor_cost + item.travel_expenses + item.rental_cost)|toFixed}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.project_loan}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.previous_cost}}</span></div></td>
                      <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.money_back}}</span></div></td>
                      <td class="ivu-table-column-center">
                        <div class="ivu-table-cell" >
                          {{item.cost}}
                        </div>
                      </td>
                      <td class="ivu-table-column-center">
                        <div class="ivu-table-cell">
                          {{item.all_cost}}
                        </div>
                      </td>
                      <td class="ivu-table-column-center">
                        <div class="ivu-table-cell center">
                          <!-- <Tag type="border" :color="pro.status=='success'?'green':'red'" v-if="pro.status!=''">
                            <Icon type="ios-checkmark-empty" v-if="pro.status=='success'"></Icon>
                            <Icon type="ios-close-empty" v-else></Icon>
                            {{pro.message}}
                          </Tag> -->
                          <Button :type="item.status==''?'primary':''" :disabled="!$menu.isPower('analysis', 'edit')" size="small" @click="edit(item)"><Icon type="edit" /></Button>
                          <Button type="default" size="small" @click="del(item.id)" :disabled="!$menu.isPower('analysis', 'del')"><Icon type="close" /></Button>
                        </div>
                      </td>
                    </tr>
                </tbody>
             </table>
         </div>
         <div class="ivu-table-fixed" style="width: 260px;">
           <div class="ivu-table-fixed-header">
             <table cellspacing="0" cellpadding="0" border="0" style="width: 260px;">
               <colgroup>
                 <col width="260"><col width="120"><col width="100"><col width="110"><col width="110"><col width="100">
                 <col width="100"><col width="100"><col width="120"><col width="100"><col width="100">
                 <col width="110"><col width="100"><col width="120"><col width="100">
               </colgroup>
               <thead>
                 <tr>
                   <!-- <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">负责人</span></div></th> -->
                   <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span>项目名称</span></div></th>
                   <!-- <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">项目地</span></div></th> -->
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">时间</span></div></th>
                   <th colspan="2" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">收入</span></div></th>
                   <th colspan="5" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">项目执行费用</span></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">项目借款</span></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">累计垫资</span></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">回款</span></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><a href="javascript:void(0);" title="(人工成本+负责人差旅+人员租赁费用+项目借款+前几月总成本-本月回款)*0.008">垫资成本</a></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><a href="javascript:void(0);" title="小计 + 垫资">项目总成本</a></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">操作</span></div></th>
                 </tr>
                 <tr>
                   <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">产值预估</span></div></th>
                   <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">调整产值</span></div></th>
                   <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">项目报销</span></div></th>
                    <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">人工成本</span></div></th>
                    <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">负责人差旅</span></div></th>
                    <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">人员租赁费</span></div></th>
                    <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">小计</span></div></th>
                  </tr>
                </thead>
               <tbody class="ivu-table-body ivu-table-overflowX">

                   <tr v-for="(item, index) in results.data" :key="index">
                      <td class="ivu-table-column-left"><div class="ivu-table-cell"><span>{{item.project.name}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.year}}年{{item.month}}月</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.value}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.new_value}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.expense}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.labor_cost}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.travel_expenses}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.rental_cost}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{(item.expense + item.labor_cost + item.travel_expenses + item.rental_cost)|toFixed}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.project_loan}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.previous_cost}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.money_back}}</span></div></td>
                      <td class="ivu-table-hidden">
                        <div class="ivu-table-cell" >
                          {{item.cost}}
                        </div>
                      </td>
                      <td class="ivu-table-hidden">
                        <div class="ivu-table-cell">
                          {{item.all_cost}}
                        </div>
                      </td>
                      <td class="ivu-table-hidden">
                        <div class="ivu-table-cell center">
                          <!-- <Tag type="border" :color="pro.status=='success'?'green':'red'" v-if="pro.status!=''">
                            <Icon type="ios-checkmark-empty" v-if="pro.status=='success'"></Icon>
                            <Icon type="ios-close-empty" v-else></Icon>
                            {{pro.message}}
                          </Tag> -->
                          <Button :type="item.status==''?'primary':''" :disabled="!$menu.isPower('analysis', 'edit')" size="small" @click="edit(item)"><Icon type="md-create" /></Button>&nbsp;
                          <Button type="default" size="small" @click="del(item.id)" :disabled="!$menu.isPower('analysis', 'del')"><Icon type="md-close" /></Button>
                        </div>
                      </td>
                    </tr>
               </tbody>
             </table>
           </div>
         </div>
         <div class="ivu-table-fixed-right" style="width: 120px;">
           <div class="ivu-table-fixed-header">
             <table cellspacing="0" cellpadding="0" border="0" style="width: 120px;">
               <colgroup>
                 <col width="120"><col width="260"><col width="100"><col width="100"><col width="100"><col width="110"><col width="100">
                 <col width="100"><col width="100"><col width="120"><col width="100"><col width="100">
                 <col width="110"><col width="100"><col width="100">
               </colgroup>
               <thead>
                 <tr>
                   <!-- <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">负责人</span></div></th> -->
                   <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">操作</span></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">项目名称</span></div></th>
                   <!-- <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">项目地</span></div></th> -->
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">时间</span></div></th>
                   <th colspan="2" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">收入</span></div></th>
                   <th colspan="5" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">项目执行费用</span></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">项目借款</span></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">累计垫资</span></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">回款</span></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><a href="javascript:void(0);" title="(人工成本+负责人差旅+人员租赁费用+项目借款+前几月总成本-本月回款)*0.008">垫资成本</a></div></th>
                   <th colspan="1" rowspan="2" class="ivu-table-hidden"><div class="ivu-table-cell"><a href="javascript:void(0);" title="小计 + 垫资">项目总成本</a></div></th>
                 </tr>
                 <tr>
                   <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">产值预估</span></div></th>
                   <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">调整产值</span></div></th>
                   <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">项目报销</span></div></th>
                    <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">人工成本</span></div></th>
                    <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">负责人差旅</span></div></th>
                    <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">人员租赁费</span></div></th>
                    <th colspan="1" rowspan="1" class="ivu-table-hidden"><div class="ivu-table-cell"><span class="">小计</span></div></th>
                  </tr>
                </thead>
               <tbody class="ivu-table-body ivu-table-overflowX">
                    <tr  v-for="(item, index) in results.data" class="ivu-table-row" :key="index">
                      <td>
                        <div class="ivu-table-cell center">
                            <!-- <Tag type="border" :color="pro.status=='success'?'green':'red'" v-if="pro.status!=''">
                            <Icon type="ios-checkmark-empty" v-if="pro.status=='success'"></Icon>
                            <Icon type="ios-close-empty" v-else></Icon>
                            {{pro.message}}
                          </Tag> -->
                          <Button :type="item.status==''?'primary':''" :disabled="!$menu.isPower('analysis', 'edit')" size="small" @click="edit(item)"><Icon type="md-create" /></Button>&nbsp;
                          <Button type="default" size="small" @click="del(item.id)" :disabled="!$menu.isPower('analysis', 'del')"><Icon type="md-close" /></Button>
                        </div>
                      </td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.project.name}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.year}}年{{item.month}}月</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.value}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.new_value}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.expense}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.labor_cost}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.travel_expenses}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.rental_cost}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{(item.expense + item.labor_cost + item.travel_expenses + item.rental_cost)|toFixed}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.project_loan}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.previous_cost}}</span></div></td>
                      <td class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{item.money_back}}</span></div></td>
                      <td class="ivu-table-hidden">
                        <div class="ivu-table-cell" >
                          {{item.cost}}
                        </div>
                      </td>
                      <td class="ivu-table-hidden">
                        <div class="ivu-table-cell">
                          {{item.all_cost}}
                        </div>
                      </td>
                    </tr>
               </tbody>
             </table>
           </div>
         </div>
       </div>
         <!-- <div style="padding:20px" v-if="step==3"> -->
           <!-- <Button type="primary">确定</Button>  -->
         <!-- </div> -->
       </div>
      <div class="pager" v-if="results && results.data.length>0">
        <Page :current="results.page" :page-size="results.per_page" :total="results.total" @on-change="pagerChange"></Page>
      </div>
      <div class="center" style="padding:40px;color:#999" v-else>-- 暂无数据 --</div>
      </template>
      <template v-else>
        <div class="center" style="padding:40px;color:#999">-- 您没有浏览权限 --</div>
      </template>
      <Modal
          v-model="uploadAnalysisModal"
          title="导入数据"
          width="600"
          :mask-closable="false">
          <div>
            <Upload
              ref="upload"
              :show-upload-list="false"
              :on-success="handleSalarySuccess"
              :format="['xls','xlsx']"
              :max-size="10048"
              :data="{file_type:'analysis_table'}"
              :headers="uploadHeaders"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload"
              type="drag"
              v-show="uploadState==0"
              :action="uploadApiPath"
               class="upload-item" style="margin:0">
                <div style="width:100%;padding: 20px 0">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>选择文件</p>
                </div>
            </Upload>
            <div v-show="uploadState==1" style="text-align:center">正在努力更新，请稍等</div>
            <div v-if="errors.length>0" style="padding:10px 0 0;">
              <Tag color="red">导入失败的项目：</Tag>
              <div style="overflow-y:scroll" :style="{height:errors.length>=5?'100px':'auto'}">
                <Alert type="error" v-for="(item, ind) in errors" :key="ind">{{item}}</Alert>
              </div>
            </div>
          </div>
          <div slot="footer">
            <a href="http://api.zjyumai.com/uploads/经营分析导入模版.xls" target="_blank" style="color:#999">模版下载 <Icon type="ios-cloud-download" size="12"></Icon></a>
          </div>
      </Modal>
    </div>
    <div class="activity-item mgui-container" slot="/analysis/count">
      <analysis-count :data="countData" :year.sync="year" @on-change="fetchCountData"></analysis-count>
    </div>
    <div class="activity-item mgui-container" slot="/analysis/year">
      <analysis-year-count></analysis-year-count>
    </div>
  </content-layout>
</template>


<script>
  import {fetch, del, post} from '../fetch/api'
  const date = new Date()
  const year = date.getFullYear()

  export default {
    name: 'BusinessAnalysis',
    components: {
      AnalysisForm: resolve => { require(['../components/AnalysisForm'], resolve) },
      AnalysisCount: resolve => { require(['../components/AnalysisCount'], resolve) },
      AnalysisYearCount: resolve => { require(['../components/AnalysisYearCount'], resolve) },
      AnalysisEditForm: resolve => { require(['../components/AnalysisEditForm'], resolve) },
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    data () {
      let token = localStorage.getItem('token')
      return {
        title: '经营分析',
        headImage: '/static/images/bg/money.jpeg',
        isChildren: false,
        tabs: [
          {'title': '经营分析', 'key': '/analysis', 'visible': true},
          {'title': '月汇总', 'key': '/analysis/count', 'visible': (Number(this.$store.state.userInfo.role) <= 1 || this.$store.state.userInfo.group_id === 1)},
          {'title': '年汇总', 'key': '/analysis/year', 'visible': (Number(this.$store.state.userInfo.role) <= 1 || this.$store.state.userInfo.group_id === 1)}
          // {'title': '修改银行资料', 'key': '/me/bank', 'visible': true}
        ],
        spinShow: true,
        activeTab: '/analysis',
        results: {
          data: []
        },
        monthVisible: false,
        analysisModal: false,
        analysisEditModal: false,
        rowData: {
          value: 0,
          new_value: 0,
          project_loan: 0,
          previous_cost: 0,
          money_back: 0,
          cost: 0,
          all_cost: 0,
          expense: 0,
          labor_cost: 0,
          travel_expenses: 0,
          rental_cost: 0
        },
        year: String(year),
        open: false,
        projects: [],
        params: {
          page: 1,
          year: year,
          month: '',
          project_id: '',
          department_id: []
        },
        columns: [
          {
            title: '项目名称',
            align: 'center',
            children: [
              {
                title: '项目报销',
                align: 'center',
                width: 100,
                render: (h, params) => {
                  let count = params.row.expense_count
                  return h('span', count.toFixed(2))
                }
              }
            ]
          }
        ],
        errors: [],
        countData: [],
        uploadList: [],
        uploadState: 0,
        uploadApiPath: '/api/users/upload/analysis',
        uploadHeaders: {
          'Authorization': `Bearer ${token}`
        },
        uploadAnalysisModal: false
      }
    },
    watch: {
      $route (to) {
        this.routeChange(to)
      }
    },
    filters: {
      toFixed (v) {
        return Number(v).toFixed(2)
      }
    },
    mounted () {
      this.routeChange(this.$route)
      this.$store.dispatch('setDepartment', false)
      // this.activeTab = this.$route.params.action === undefined ? 'info' : 'password'
      if (this.activeTab !== '/analysis') {
        this.isChildren = true
      }
    },
    methods: {
      refresh () {
        this.analysisModal = false
        this.analysisEditModal = false
        // if (Number(this.$store.state.userInfo.role) <= 1)
        this.fetchData()
      },
      create () {
        this.analysisModal = true
      },
      yearChange (year) {
        this.params.year = year
        this.fetchData()
      },
      edit (row) {
        this.rowData = JSON.parse(JSON.stringify(row))
        this.analysisEditModal = true
      },
      del (id) {
        this.$Modal.confirm({
          title: '删除确认',
          content: '确定删除该记录吗(删除后无法恢复)？',
          onOk: () => {
            del(`business/analysis/${id}`).then(res => {
              if (res.status === 'ok') {
                this.$Message.info('删除成功')
              }
              this.refresh()
            })
          }
        })
      },
      pagerChange (page) {
        this.params.page = page
        this.fetchData()
      },
      routeChange (route) {
        let action = route.params.action

        if (action === undefined) {
          if (Number(this.$store.state.userInfo.role) === 1 || Number(this.$store.state.userInfo.group_id) === 1) {
            this.activeTab = '/analysis'
            this.fetchData()
          } else {
            this.activeTab = '/analysis/count'
            this.fetchCountData()
          }
        } else if (action === 'count') {
          this.activeTab = '/analysis/count'
          this.fetchCountData()
        } else if (action === 'year') {
          this.activeTab = '/analysis/year'
          // this.fetchYearCountData()
        }
      },
      departmentChange (item) {
        this.params.page = 1
        if (item) {
          let data = JSON.parse(item)
          this.params.department_id = data.value
          this.projects = data.children
        } else {
          this.params.department_id = ''
          this.projects = []
        }
        this.fetchData()
      },
      projectChange () {
        this.params.page = 1
        this.fetchData()
      },
      exportAnalysis () {
        var dom = document.getElementById('ifile')
        post('users/export/analysis', this.params).then(res => {
          if (res.status === 'success') {
            this.$Modal.success({
              title: '请求成功',
              content: '正在尝试生成excel数据, 请耐心等待...',
              okText: '关闭'
            })
            dom.src = this.apiPath + `export/analysis?cry=${res.cry}`
          }
        })
      },
      fetchCountData () {
        fetch('business/analysis/count', {params: {year: this.year}}).then(res => {
          var data = res
          if (!Array.isArray(data)) return
          var allCount = {
            name: '汇总',
            director: {
              username: '--'
            },
            projects: [{
              total_value: 0,
              total_new_value: 0,
              total_all_cost: 0,
              total_all_expense:0,
              name: '全部',
              analysisList: []
            }]
          }
          // console.log(data)
          for (var k in data) {
            if (data.hasOwnProperty(k)) {
              var total = {
                total_value: 0,
                total_new_value: 0,
                total_all_cost: 0,
                total_all_expense: 0,
                expense: 0,
                name: '总计',
                analysisList: []
              }
              var projects = data[k].projects
              for (var key in projects) {
                if (projects.hasOwnProperty(key)) {
                  var analysisList = projects[key].analysisList
                  total.total_value += projects[key].total_value
                  total.total_new_value += projects[key].total_new_value
                  total.total_all_cost += projects[key].total_all_cost
                  total.total_all_expense += projects[key].total_all_expense
                  for (var i in analysisList) {
                    if (analysisList.hasOwnProperty(i)) {
                      if (total.analysisList[i] === undefined) {
                        total.analysisList[i] = {value: analysisList[i].value, new_value: analysisList[i].new_value, expense:analysisList[i].expense,all_cost: analysisList[i].all_cost, month: analysisList[i].month, type: 'count'}
                      } else {
                        total.analysisList[i].value += analysisList[i].value
                        total.analysisList[i].new_value += analysisList[i].new_value
                        total.analysisList[i].all_cost += analysisList[i].all_cost
                        total.analysisList[i].total_all_expense += analysisList[i].expense
                      }
                    }
                  }
                }
              }

              if (projects) {
                data[k].projects.push(total)
                for (var x in total.analysisList) {
                  // console.log(allCount.projects[0].analysisList[x])
                  if (allCount.projects[0].analysisList[x] === undefined) {
                    allCount.projects[0].analysisList[x] = {value: total.analysisList[x].value, new_value: analysisList[x].new_value, expense:analysisList[x].expense,all_cost: total.analysisList[x].all_cost, month: total.analysisList[x].month, type: 'allcount'}
                  } else {
                    allCount.projects[0].analysisList[x].value += total.analysisList[x].value
                    allCount.projects[0].analysisList[x].new_value += total.analysisList[x].new_value
                    allCount.projects[0].analysisList[x].all_cost += total.analysisList[x].all_cost
                    allCount.projects[0].analysisList[x].total_all_expense += total.analysisList[x].expense
                  }
                }
                allCount.projects[0].total_value += total.total_value
                // allCount.projects[0].total_new_value += total.total_new_value
                allCount.projects[0].total_all_cost += total.total_all_cost
                allCount.projects[0].expense += total.expense
                allCount.projects[0].total_all_expense += total.total_all_expense
              }
            }
          }
          data.push(allCount)
          this.countData = res
          this.spinShow = false
        })
      },
      lastYear () {
        this.params.year --
        this.fetchData()
      },
      nextYear () {
        this.params.year ++
        this.fetchData()
      },
      handleClick () {
        this.open = !this.open
      },
      handleChange (year) {
        this.params.year = year
      },
      handleOk () {
        this.open = !this.open
        this.fetchData()
      },
      fetchData () {
        fetch('business/analysis', {params: this.params}).then(res => {
          this.results = res
          this.spinShow = false
        })
      },
      handleSalarySuccess (res) {
        if (res.status === 'ok') {
          this.uploadState = 0
          this.$Message.success(res.msg)
          this.errors = res.errors
        // this.attendSalaryMonth = res.time
          this.fetchData()
        } else {
          this.$Message.error(res.msg)
        }
      },
      handleFormatError (file) {
        this.$Notice.warning({
          title: '上传错误',
          desc: '您上传的文件可能有误【' + file.name + '】, 请选择xls/xlsx文件.'
        })
      },
      handleMaxSize (file) {
        this.$Notice.warning({
          title: '文件太大',
          desc: '文件  ' + file.name + ' 太大了, 请不要超过 2M.'
        })
      },
      handleBeforeUpload () {
        const check = this.uploadList.length <= 1
        this.uploadState = 1
        if (!check) {
          this.uploadState = 0
          this.$Notice.warning({
            title: '一次只能选择一个文件！'
          })
        }
        return check
      }
    }
  }
</script>

<style scope>
.analysis-table .ivu-table-border td, .analysis-table .ivu-table-border th{border-bottom:none}
</style>
